// 用户登录信息
import { observable, action, computed, toJS } from 'mobx'
import request from '@/common/request'

class User {
  @observable _userinfo = {}
  @observable _userResource = {}

  @action
  async login (user) {
    return request({
      url: '/user/login',
      method: 'post',
      data: user
    })
  }

  @action
  async setUserInfo (userinfo) {
    this._userinfo = userinfo
    localStorage.setItem('loginUserBaseInfo', JSON.stringify(toJS(this._userinfo)))
  }
  async setUserResource (userResource) {
    this._userResource = userResource
    localStorage.setItem('loginUserResource', JSON.stringify(toJS(this._userResource)))
  }

  @computed
  get userinfo () {
    return localStorage.loginUserBaseInfo ? JSON.parse(localStorage.loginUserBaseInfo) : null
  }
  get userResource () {
    return localStorage.loginUserResource ? JSON.parse(localStorage.loginUserResource) : null
  }
}

export default new User()



// WEBPACK FOOTER //
// ./src/stores/user.js